export function stripTags(str) {
  if (str === null || str === '') return false;
  else str = str.toString();
  return str.replaceAll(/(<([^>]+)>)/gi, '');
}
